import { CtaButton, Modal, TextBody, TextHero } from '@tkww/orion-web-ds';
import React, { type FC } from 'react';
import Styles from './styles.scss';

type CloseModalProps = {
	title: string;
	text?: string;
	confirmButtonText: string;
	cancelButtonText: string;
	onConfirm: () => void;
	onCancel: () => void;
	onClose?: () => void;
};

export const CloseModal: FC<CloseModalProps> = ({
	title,
	text,
	confirmButtonText,
	cancelButtonText,
	onConfirm,
	onCancel,
	onClose,
}) => {
	return (
		<Modal size="sm" onClose={onClose || onCancel}>
			<div className={Styles.container}>
				<div className={Styles.contentWrapper}>
					<TextHero size="sm">{title}</TextHero>
					<TextBody size="md" className={Styles.text}>
						{text}
					</TextBody>
				</div>
				<div className={Styles.actionsWrapper}>
					<div className={Styles.buttonsWrapper}>
						<CtaButton
							as="button"
							treatAs="button"
							styleType="primary"
							size="lg"
							onClick={onConfirm}
						>
							{confirmButtonText}
						</CtaButton>
						<CtaButton
							as="button"
							treatAs="button"
							styleType="secondary-alternative"
							size="lg"
							onClick={onCancel}
						>
							{cancelButtonText}
						</CtaButton>
					</div>
				</div>
			</div>
		</Modal>
	);
};
